import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  company: {},
  cachedCompany: {},
  companies: {},
  cachedCompanies: {},
  companyById: {},
  cachedCompanyById: {},
};

export default {
  actions,
  getters,
  mutations,
  state,
};
